// --- Core ---
// --- Material UI ---
import {Grid, useTheme} from "@mui/material";
// --- SaniQ ---
import {Image} from "src/helpers/RenderUtil";
import {CorporateIdentityContext} from "../../../config/corporateIdentity";
import {CSSProperties, ReactNode, useContext} from "react";
import {AppLogo} from "shared/layout/AppLogo";

interface LogoProps {
  text?: string | ReactNode;
  p?: number;
  isAppLogo?: boolean;
  imgStyle?: CSSProperties;
}

const Logo = ({isAppLogo, p}: LogoProps) => {
  const theme = useTheme();
  const corporateIdentity = useContext(CorporateIdentityContext);
  const logo = corporateIdentity[`logo_${theme.palette.mode}_path`];

  return (
    <Grid item>
      {
        isAppLogo ? <AppLogo sx={p}/> :
          (
            <Image
              src={logo}
              alt="Praxis Logo"
              sx={
                isAppLogo ?
                  {
                    borderRadius: 2,
                    border: "1px solid #e0e0e0",
                    height: theme => theme.spacing(7),
                    p
                  } :
                  {
                    height: theme => theme.spacing(8),
                    p
                  }
              }
            />
          )
      }
    </Grid>
  );
};

export default Logo;
